var mask = "/static/9749b7f2f9951091.png";

export { mask as default };
//# sourceMappingURL=mask.png.js.map
